import { createAction } from "@reduxjs/toolkit";

export const fullLogout = createAction("LOGOUT");
export const changePolicy = createAction("CHANGE_POL");
export const clearPolicyInfo = createAction("CLEAR_POLICY_UPDATE_INFO");
export const clearStoreOnLogin = createAction("CLEAR_STORE_ON_LOGIN");

